import createRoute from '@widesk-ui/tools/createRoute';
import MenuModel   from '@models/shop/MenuModel';

export default createRoute.splitView('/menus', 'shop', 'MenuSplitView', MenuModel.localize('plural'));
